import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useDispatch, useSelector } from 'react-redux'
import {changeDeliveriesModal} from '../../../../redux/actions/deliveries'

import './style.scss'

const Index = () => {

    const dispatch = useDispatch()
    const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)

    const deleteLoading = useSelector(state => state.library.deleteArrayLoading)

    const clickAddNewDelivery = () => {
        if(activeCompany && activeCompany.subscription){
            dispatch(changeDeliveriesModal({newModal: true}))
        }
    }

    const determineAddButtonClick= () => {
        if(activeCompany && activeCompany.subscription){
            clickAddNewDelivery()
        } 
    }

    return(
        <section className="dashboard-deliveries-upper-row-section">
            <Row className="upper-row">
                <Col md={6} className="text-left title-col my-auto">
                    <Col className="inner-title-col">
                        <h3 className="page-title"><i class="fad fa-box-full"></i> Leveranser</h3>
                    </Col>
                </Col>
                <Col md={6} className="text-right button-col my-auto">
                    <Col className="inner-button-col">
                        <button className="delete-deliveries-button"><i className={deleteLoading ? "fas fa-circle-notch fa-spin":"fas fa-trash-alt"}></i> {deleteLoading ? "Sletter..":"Slett leveranser"}</button>
                        <button onClick={() => determineAddButtonClick()} className="new-delivery-button"><i className="fas fa-plus"></i> Ny leveranse</button>
                    </Col>
                </Col>
            </Row>
        </section>
    )
}

export default Index
